<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true" :model="dataForm" @keyup.enter.native="network().getDataSetList()">
				<el-form-item>
					<el-input style="width: 20rem;" v-model="dataForm.keyword" placeholder="请输入知识库名称搜索" clearable
						suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="network().getDataSetList()">搜索</el-button>
					<el-button type="" @click="event().clearSearch()">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" @click="addAdminClick('新增')">新增知识库</el-button>
				</el-form-item>
				<!-- <el-form-item style="float: right;">
				<el-button type="primary" @click="network().regionexport()">导出</el-button>
			</el-form-item> -->
			</el-form>
			<el-table :data="tableData" border style="width: 100%" class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}">
				<el-table-column type="index" label="序号" align="center" width="200">
				</el-table-column>
				<el-table-column prop="name" label="知识库名称" align="center">
				</el-table-column>
				<el-table-column prop="desc" label="知识库简介" align="center">
				</el-table-column>
				<!-- <el-table-column prop="desc" label="是否应用到对话模块" align="center">
					<template slot-scope="scope">
						{{scope.row.is_chat==1?'否':'是'}}
					</template>
				</el-table-column> -->
				<el-table-column prop="create_time" label="创建时间" align="center">
				</el-table-column>
				<el-table-column label="操作" width="300px" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" @click="viewData(scope.row)">
								<i class="el-icon-view" style="color: #409EFF;"></i>查看</span>
							<span class="operation-item" @click="editAdminClick(scope.row)">
								<i class="el-icon-edit"></i>编辑</span>
							<span class="operation-item delete" @click="deleteClick(scope.row)">
								<i class="el-icon-delete"></i>删除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<common-dialog :title="dialogTitle" :dialogVisible="dialogVisible" @cancel="dialogCancelClick"
				@confirm="dialogConfirmClick" @dialog-close="dialogClose">
				<div class="dialog-body-wrap">
					<div v-if="dialogType ==='delete'">
						是否删除知识库？
					</div>
				</div>
			</common-dialog>
			<city-dialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
				@confirm="confirmDialog">
			</city-dialog>
			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>
		</el-card>
	</div>
</template>

<script>
	import operations from "@/mixins/operations";
	import CityDialog from './components/CityDialog.vue'
	import CommonDialog from "@/components/CommonDialog";
	import {
		getDataSetList,
		regiondel,
		regionexport,
		deleteDataSet
	} from "@/api/area-manage"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"
	import CommonPagination from "@/components/CommonPagination";

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				total: 0,
				page_size: 10,
				page_index: 1,
				tableData: [],
				dataForm: {
					keyword: "",
					level: "",
					is_blacklist: 0
				},
				uuid: '',
				//删除弹框开始
				dialogTitle: "",
				dialogType: "",
				dialogVisible: false,
				form: {},
				//删除弹框结束
				//添加/修改
				selectForm: {},
				editdialogVisible: false,
			};
		},
		components: {
			CityDialog,
			CommonDialog,
			CommonPagination
		},
		mounted() {
			this.uuid = this.$route.query.uuid
			this.network().getDataSetList();
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			viewData(item) {
				this.$router.push({
					path: '/add-city-detail?uuid=' + item.uuid,
				})
			},
			editCityList(row) {
				this.$router.push({
					path: '/add-city-list',
					query: row
				})
			},
			//删除弹框开始
			dialogCancelClick: () => {
				this.dialogVisible = false
			},
			async dialogConfirmClick() {
				if (this.dialogType === "delete") {
					let postData = {
						id: this.form.uuid
					}
					const {
						status
					} = await deleteDataSet(postData);
					this.$message.success('删除成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
			},
			dialogClose() {
				this.dialogVisible = false;
				this.network().getDataSetList();
			},
			deleteClick(row) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "delete";
				this.dialogTitle = "删除知识库";
			},
			//删除弹框结束
			//添加
			addAdminClick() {
				this.selectForm = {};
				// this.selectForm.role_uuid = this.uuid
				// this.editdialogVisible = true;
				this.$router.push({
					path: '/add-city-list'
				})
			},
			//修改
			editAdminClick(row) {
				this.$router.push({
					path: '/add-city-list?uuid=' + row.uuid
				})
			},
			closeDialog(row) {
				console.log(row)
				this.editdialogVisible = row;
			},
			confirmDialog(row) {
				this.editdialogVisible = row;
				this.network().getDataSetList()
			},
			handlePageChange(page) {
				this.event().handlePageChange(page);
			},
			handleSizeChange(size) {
				this.event().handleSizeChange(size);
			},
			//添加修改结束
			/**
			 *触摸，响应事件放在event下，如onclick函数,onchange函数等
			 *特殊情况:像一些需要接收参数的事件，如onchange原生事件或者是vue中的emit有参数的事件,必须得写在event外部，否则无法得到接收参数。像这种事件特殊处理
			 **/
			event() {
				return {
					clearSearch: async () => {
						this.page_index = 1
						this.dataForm.keyword = ''
						this.network().getDataSetList()
					},
					toggleTab: (index) => {
						this.allChioce = [];
						this.dataForm.is_blacklist = index
						this.network().getDataSetList();
					},
					handlePageChange: (page) => {
						this.page_index = page;
						this.network().getDataSetList();
					},
					handleSizeChange: (size) => {
						this.page_size = size;
						this.network().getDataSetList();
					},
				}
			},
			/**
			 *网络访问相关函数
			 **/
			network() {
				return {
					getDataSetList: async () => {
						let postData = {
							page_size: this.page_size,
							page_index: this.dataForm.keyword ? 1 : this.page_index,
							keyword_search: this.dataForm.keyword,
						};
						const {
							status,
							data
						} = await getDataSetList(postData);
						if (status !== 200) return;
						this.tableData = data.result.data;
						this.total = data.result.total;
					},
					regionexport: async () => {
						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
							op: {
								area_name: 'LIKE'
							},
							filter: {
								area_name: this.dataForm.keyword,
								parent_id: 0
							}
						};
						const {
							status,
							data
						} = await regionexport(postData);
						if (status !== 200) return;
						utils.blobLoadDownLoad(data, "城市列表.xls");
					},
				}
			},
			/**
			 * 一般放处理业务逻辑较多的私人函数
			 **/
			handler() {
				return {
					handleListA(list) {
						for (var i = 0; i < list.length; i++) {
							//handle service
						}
					},
					/**
					 **校验表单输入
					 **/
					verifyInput() {},

				}
			}

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.table-wrap {
		.table-wrap(5px);
	}

	.m-content {
		width: 12rem;
	}

	.m-tab {
		position: relative;
		margin-bottom: 2.1875rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-tab-item {
		padding-right: 2.0625rem;
		color: #8D8EA6;
		font-size: 1.375rem;
		text-align: center;
	}

	.m-tab-item-active {
		color: #409eff;
	}

	.tab-line {
		height: 2px;
		background: #409eff;
		position: absolute;
		bottom: 0;
		transition: all 0.3s ease;
	}

	.tab-line-0 {
		width: 3rem;
		left: 0;
	}

	.tab-line-1 {
		width: 5rem;
		left: 1;
	}
</style>